import React from 'react'
import SnowEffect from '../../SnowEffect'
import { ButtonBase } from '@material-ui/core'

import Reposition from '../../../assets/images/RepostionCamera.png'

import '../../../pages/GamePages.scss'

export default class SnowballLanding extends React.Component {
  state = {
    mounted: false,
  }

  componentDidMount () {
    this.setState({mounted: true})
  }
  render = () => {
    return (
      <div className={`landing-screen ${this.state.mounted ? 'mounted' : ''}`} onClick={() => { this.props.action('landing') }}>
        <SnowEffect />
        <div className='content'>
          {this.props.loaded && (
            <div className='copy'>
              <p>Hold your phone upright and tap anywhere to place a portal, then enter a wonderland of possibilities.</p>
              <p>Tap this if you get lost.</p>
              <img src= {Reposition} alt="" />
              <ButtonBase onClick={() => { this.props.action('landing')}} className="button">Continue</ButtonBase>
            </div>
          )}
          {!this.props.loaded && (
            <div className='copy'>
              <p><strong>Loading...</strong></p>
            </div>
          )}
        </div>
      </div>
    )
  }
}
